/**
 * Invitado persistente compartido entre flujos web-payment (booking, foodtruck, etc.).
 * Misma clave que BookingPage para que sea la misma identidad anónima por tenant.
 */
export function webPaymentGuestStorageKey(tenantId: string): string {
  return `booking_guest_id_${tenantId}`;
}

export function getOrCreateWebPaymentGuestId(tenantId: string): string | undefined {
  if (typeof window === 'undefined' || !tenantId) return undefined;
  try {
    const key = webPaymentGuestStorageKey(tenantId);
    let value = localStorage.getItem(key);
    if (!value) {
      value =
        typeof crypto !== 'undefined' && crypto.randomUUID
          ? crypto.randomUUID()
          : `guest-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
      localStorage.setItem(key, value);
    }
    return value;
  } catch {
    return undefined;
  }
}

/** Pantalla login vs invitado (foodtruck web con Clerk). */
export function foodtruckIdentityGateStorageKey(tenantId: string): string {
  return `foodtruck_id_gate_${tenantId}`;
}

export function foodtruckGuestContactStorageKey(tenantId: string): string {
  return `foodtruck_guest_contact_${tenantId}`;
}

/** Email guardado tras identidad / flujo web booking (por tenant). */
export function webBookingGuestEmailStorageKey(tenantId: string): string {
  return `booking_web_guest_email_${tenantId}`;
}

export function getWebBookingGuestEmail(tenantId: string): string | null {
  if (typeof window === 'undefined' || !tenantId) return null;
  try {
    const v = localStorage.getItem(webBookingGuestEmailStorageKey(tenantId))?.trim();
    if (!v || !v.includes('@')) return null;
    return v;
  } catch {
    return null;
  }
}

export function setWebBookingGuestEmail(tenantId: string, email: string): void {
  if (typeof window === 'undefined' || !tenantId) return;
  const t = email.trim().toLowerCase();
  if (!t || !t.includes('@')) return;
  try {
    localStorage.setItem(webBookingGuestEmailStorageKey(tenantId), t);
  } catch {
    // ignore
  }
}

/** WhatsApp ID persistido para mostrar historial en la landing. */
export function webBookingWaIdStorageKey(tenantId: string): string {
  return `booking_web_wa_id_${tenantId}`;
}

export function getWebBookingWaId(tenantId: string): string | null {
  if (typeof window === 'undefined' || !tenantId) return null;
  try {
    return localStorage.getItem(webBookingWaIdStorageKey(tenantId))?.trim() || null;
  } catch {
    return null;
  }
}

export function setWebBookingWaId(tenantId: string, waId: string): void {
  if (typeof window === 'undefined' || !tenantId) return;
  const v = waId.trim();
  if (!v) return;
  try {
    localStorage.setItem(webBookingWaIdStorageKey(tenantId), v);
  } catch {
    // ignore
  }
}
